import pug from 'javascripts/search/templates/research_interest_result.jst.pug';
window.JST = window.JST || {};
window.JST['search/templates/research_interest_result'] = pug;
